"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Cn;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Cn(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Brands"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "cn",
    d: "M78.258,78.28a40.226,40.226,0,0,1-9.728,7.152C73.121,78.961,63.383,66.816,48,46.909c-3.571-4.554-6.992-8.93-9.74-13.034A163.657,163.657,0,0,0,50.545,44.727C71.081,61.374,81.487,70.166,78.258,78.28ZM62.57,87.966A39.963,39.963,0,0,1,28.617,16.259c-3.75,8.95,6.608,24.681,20.838,42.468C61.113,73.183,68.506,82.851,62.57,87.966Zm-7.661-1.057C34,86.546,18.182,69.455,16.545,49.455a46.072,46.072,0,0,1-.1-7.256,42.852,42.852,0,0,1,3.527-14.074,45.165,45.165,0,0,1,3.481-6.307,14.275,14.275,0,0,0-3.091,3.091C13.818,34,12.182,41.636,12.545,51.455c.91,19.818,16.728,36.181,35.819,36.181A28,28,0,0,0,54.909,86.909ZM33.553,13.559C29.385,20.246,41.112,29.455,54.182,40c7.295,5.78,13.391,10.762,18.072,15.173a176.564,176.564,0,0,0-12.072-15.9c-9.8-11.836-18.976-23.67-15.744-28.879A39.7,39.7,0,0,0,33.553,13.559ZM48.6,10.036c-2.686,3.492,3.306,11.041,6.132,14.509,6.182,7.637,13.091,14.91,18.909,22.728a71.315,71.315,0,0,1,7.455,12.182c2.426,5.3,2.983,9.179,2.512,12.231A39.99,39.99,0,0,0,50,10C49.529,10,49.062,10.019,48.6,10.036Z"
  })));
}